import React from 'react';
import type { ReactNode } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { Container } from '../ui/Container';
interface PageShellProps {
  title: string;
  eyebrow?: string;
  intro?: string;
  image?: string;
  imageAlt?: string;
  children: ReactNode;
}
export function PageShell({
  title,
  eyebrow = 'Bates Taekwondo',
  intro,
  image,
  imageAlt = '',
  children
}: PageShellProps) {
  return <div className="min-h-screen bg-paper text-ink" data-id="element-426" data-mp="h37tpwe9strx">
      <Header data-id="element-427" data-mp="c44w2x0mdptz" />
      <main id="main" tabIndex={-1} data-id="element-428" data-mp="c4o33ioqett8">
        <section className="border-b border-line bg-white py-12 sm:py-16 lg:py-20" data-id="element-429" data-mp="c5fwcmuuwfgc">
          <Container className={image ? 'grid items-center gap-9 lg:grid-cols-2 lg:gap-14' : ''} data-id="element-430" data-mp="qu2bookhh77k">
            <div data-id="element-431" data-mp="m07z053apshz">
              <a href="/" className="mb-7 inline-flex min-h-[44px] items-center text-sm font-medium text-muted underline underline-offset-4 hover:text-ink" data-id="element-432" data-mp="lzptsiyno3xx">Home</a>
              <p className="mb-4 text-sm font-semibold uppercase tracking-[0.15em] text-brand" data-id="element-433" data-mp="3phq444roolep">{eyebrow}</p>
              <h1 className="max-w-4xl text-balance font-display text-[3.1rem] font-bold uppercase leading-[0.95] sm:text-[4rem] lg:text-[4.75rem]" data-id="element-434" data-mp="1xvc3ndaihah2">{title}</h1>
              {intro && <p className="text-pretty mt-6 max-w-[43rem] text-lg leading-relaxed text-muted" data-id="element-435" data-mp="26o5p5sgjx63d">{intro}</p>}
            </div>
            {image && <img src={image} alt={imageAlt} className="aspect-[4/3] w-full rounded object-cover" data-id="element-436" data-mp="2bn0j9qjyyh2s" />}
          </Container>
        </section>
        <Container className="space-y-14 py-12 sm:space-y-16 sm:py-16 lg:py-20" data-id="element-437" data-mp="1iyuy52p06q2f">{children}</Container>
      </main>
      <Footer data-id="element-438" data-mp="1ny7kznfvjx50" />
    </div>;
}